import React, { useState } from "react"
import { CardWrapper, MainCardContent, Details } from "./Card.styles"
import { AiOutlineInfoCircle, AiOutlineClose } from "react-icons/ai"

const Card = ({ src, title, projectTitle, text, description }) => {
  const [isOpen, setOpen] = useState(false)

  return (
    <CardWrapper onClick={() => setOpen(!isOpen)}>
      <div></div>
      {/* {!isOpen && ( */}
      <MainCardContent isOpen={isOpen}>
        <img src={src} alt="" />
        <div className="description">
          <p className="title">
            {title}
            <i>
              <AiOutlineInfoCircle />
            </i>
          </p>
          <p className="projectTitle">{projectTitle} </p>
          <p>{text}</p>
        </div>
      </MainCardContent>
      {/* )} */}
      {/* {isOpen && ( */}
      <Details isOpen={isOpen}>
        <p>
          {title}
          <i>
            <AiOutlineClose />
          </i>
        </p>
        <p>
          {`Bezvezze is a dating app from a Swiss startup. The app is available
          both on iOS, on Android and as a web application.`}
          <br />
          <br />

          {`The app had been developed thanks to the Ionic framework on the front end and in php on the backend.`}
          <br />
          <br />
          {`The Ionic
          framework allowed us to have a seamless experience on 3 different
          platform (iOS, Android and the web) with only one source code. More
          information on https://bezvezze.com.`}
        </p>
      </Details>
      {/* )} */}
    </CardWrapper>
  )
}

export default Card
